<template>
	<div class="widget__table">
		<div class="table-files">
			<Row v-for="file in files" :file="file" :key="file.id" />
		</div>
	</div>
</template>

<script>
/**
 * The internal dependencies.
 */
import Row from '@components/Files/Row.vue';

export default {
	props: {
		files: {
			required: true,
		}
	},

	components: {
		Row,
	},
};
</script>

<style>
	.widget__table {
		max-height: 300px;
		overflow: auto;
	 }

	/*  Table Files  */

	.table-files .table__row {
		display: flex;
		flex-wrap: wrap;
		padding: 16px;
	    background-color: var(--color-white);
		border: 1px solid var(--color-gray-300);
		border-radius: var(--border-radius-1);
 	}

	 .table-files .table__row:not(:last-child){
		margin-bottom: 4px;
	 }

	.table-files .table__cell { box-sizing: border-box; }
	.table-files .table__cell p { font-size: 11px; }

	.table-files .table__cell-entry { flex: 1 0 85%; padding-right: 10px; }
	.table-files .table__cell-entry h5 {  font-size: 13px; word-break: break-word; }

	.table-files .table__cell-date { flex: 0 1 15%; text-align: right; }

	.table-files .table__cell-links { flex: 1 1 100%; padding-top: 8px; }
	.table-files .table__cell-links ul { display: flex; flex-wrap: wrap; list-style: none outside none; line-height: 1; }
	.table-files .table__cell-links ul li { position: relative; font-size: 11px; padding-right: 5px; margin-right: 5px; line-height: 1.3; }
	.table-files .table__cell-links ul li:not(:last-child):before { position: absolute; top: 0; bottom: 0; right: 0; width: 1px; background-color: currentColor; content: ''; }

	.table-files .table__cell-links a { font-size: 11px; }
	.table-files .table__cell-links a:hover { text-decoration: none; }
</style>
